// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6ca0ade9","239":"dc6ac21d","732":"7f151395"}[chunkId] + ".chunk.js";
};